import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@contexts/AuthContext';
import { referenceListService, supplierService } from '@services';
import {
  REFERENCE_CATALOG_QUERY_KEY,
  SUPPLIER_TIERS_QUERY_KEY,
  setReferenceCatalog,
  resolveLabel,
  listOptions,
  type CatalogTier,
} from '@utils/referenceCatalog';
import type { ReferenceList } from '@app-types/reference-list';

const STALE_TIME = 5 * 60 * 1000;

export function useReferenceCatalog() {
  const { isAuthenticated } = useAuth();

  const listsQuery = useQuery({
    queryKey: REFERENCE_CATALOG_QUERY_KEY,
    queryFn: () => referenceListService.getCatalog(),
    staleTime: STALE_TIME,
    enabled: isAuthenticated,
  });

  const tiersQuery = useQuery({
    queryKey: SUPPLIER_TIERS_QUERY_KEY,
    queryFn: () => supplierService.getSupplierTiers(),
    staleTime: STALE_TIME,
    enabled: isAuthenticated,
  });

  const lists: ReferenceList[] = listsQuery.data ?? [];
  const tiers: CatalogTier[] = (tiersQuery.data ?? []).map((tier) => ({
    code: tier.code ?? '',
    name: tier.name,
  }));

  setReferenceCatalog(lists, tiers);

  return {
    lists,
    isLoading: listsQuery.isLoading || tiersQuery.isLoading,
    resolveLabel,
    listOptions,
    tierNames: tiers.map((tier) => tier.name),
  };
}
